import styled, { css } from 'styled-components';
import { ItemType } from './';

export const FormItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
`;

export const LabelWrapper = styled.div``;

interface ChildrenWrapperProps {
    itemType?: ItemType;
    itemSpace?: number;
    itemRadius?: number;
    width?: number;
}

export const ChildrenContainer = styled.div<ChildrenWrapperProps>`
    width: 100%;
    margin-top: 8px;
    
    ${props => {
        return css`
            ${ChildrenWrapper},
            ${ChildrenWrapperRow},
            ${ChildrenWrapperRowBetween},
            ${ChildrenWrapperRowStart} {
                display: flex;
                width: ${props.width ? css`${props.width}px` : '100%'};
            }
        `;
    }}

    ${props => {
        if (props.itemType === 'ROW') {
            return css`
                ${ChildrenWrapperRow} {
                    > * { border-radius: 0; }
                    ${props.itemRadius ?
                    css`
                            > *:first-child { border-radius: ${props.itemRadius}px 0px 0px ${props.itemRadius}px; }
                            > *:last-child { border-radius: 0px ${props.itemRadius}px ${props.itemRadius}px 0px; }
                        `
                    : css` 
                            > *:first-child { border-radius: 8px 0px 0px 8px; }
                            > *:last-child { border-radius: 0px 8px 8px 0px; }
                        `
                }
                }
            `;
        } else if (props.itemType === 'ROW-START') {
            return css`
                ${ChildrenWrapperRowStart} {
                    justify-content: flex-start;
                    ${props.itemSpace ? css`> *:not(:last-child) {margin-right: ${props.itemSpace}px;}` : null}
                }
            `;
        } else if (props.itemType === 'ROW-BETWEEN') {
            return css`
                ${ChildrenWrapperRowBetween} {
                    justify-content: space-between;
                    ${props.itemSpace ? css`> *:not(:last-child) {margin-right: ${props.itemSpace}px;}` : null}
                }
            `;
        } else {
            return css`
                ${ChildrenWrapper} {
                    flex-direction: column;
                    > *:not(:last-child) {
                        margin-bottom: ${props.itemSpace ? props.itemSpace : '4'}px;
                    }
                }
            `;
        }
    }}
`;

export const ChildrenWrapperRow = styled.div`
`;

export const ChildrenWrapperRowStart = styled.div`
`;

export const ChildrenWrapperRowBetween = styled.div`
`;

export const ChildrenWrapperSurvey = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

export const ChildrenWrapper = styled.div`
`;

export const CaptionWrapper = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: column;
`;

export const OptionalChildrenWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    > *:not(:last-child) {
        margin-right: 12px;
    }
`;
